import { render, staticRenderFns } from "./RequirementMarker.vue?vue&type=template&id=357b91bf&"
import script from "./RequirementMarker.vue?vue&type=script&lang=js&"
export * from "./RequirementMarker.vue?vue&type=script&lang=js&"
import style0 from "./RequirementMarker.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports